import PeopleCardDataPointConfig from '../store/schema/PeopleCardDatapointConfig';
import PeopleCardMountProps from '../store/schema/PeopleCardMountProps';
import PeopleCardRoute from '../store/schema/PeopleCardRoute';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';

export default action(
    'setPeopleCardRoute',
    (
        route: PeopleCardRoute,
        peopleCardMountProps?: PeopleCardMountProps,
        datapointConfig?: PeopleCardDataPointConfig
    ) =>
        addDatapointConfig(
            {
                name: 'LaunchPeopleCard',
                customData: { ...datapointConfig },
                options: { isCore: true },
            },
            { route, peopleCardMountProps }
        )
);
